import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}periodos`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}periodos/get/list`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}periodos/${id}`);
  return response;
};

const getDetail = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}periodos/details/by/${id}`);
  return response;
};

const getDetailsById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}periodos/details/${id}`);
  return response;
};

const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}periodos`, payload);
  return response;
};

const insertDetail = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}periodos/details`, payload);
  return response;
};

const updateDetail = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}periodos/details`, payload);
  return response;
};

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}periodos`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}periodos/${id}`);
  return response;
};

const dropDetail = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}periodos/details/${id}`);
  return response;
};


export { getAll, getList, getById, getDetail, getDetailsById, insert, insertDetail, updateDetail, update, drop, dropDetail };
